<p-dialog
  [(visible)]="display"
  header="{{ header }}"
  appendTo="body"
  [draggable]="false"
  width="400"
>
  <span>{{ content }}</span
  ><br /><br />

  <div class="checkbox-container">
    <p-checkbox
      [(ngModel)]="checkboxValue"
      inputId="confirm-with-checkbox-chk"
      binary="true"
    ></p-checkbox>
    <label for="confirm-with-checkbox-chk">{{ checkboxLabel }}</label>
  </div>

  <ng-template #footer>
    <p-button
      type="button"
      (click)="onConfirm()"
      label="{{ 'label.Yes' | translate }}"
    ></p-button>
    <p-button
      type="button"
      (click)="onCancel()"
      label="{{ 'label.No' | translate }}"
    ></p-button>
  </ng-template>
</p-dialog>
<a (click)="onActionClick()">{{ actionName }}</a>
